import { RootState } from '../reducer';
import { AuthState } from 'store/auth/types';

export const authState = (state: RootState): AuthState => state.auth;
